import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EventTypes } from '@models/server-common';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { AuthenticatedUser } from '@quorum/authentication/state';
import { Conversation } from '@quorum/communicator/state/conversations';
import { EventsStateService } from '@quorum/communicator/state/events';
import { Event, TokenUser } from '@quorum/models/xs-resource';
import { take, tap } from 'rxjs/operators';

@Component({
  selector: 'com-conversation-extended-warranty',
  templateUrl: './conversation-extended-warranty.component.html',
  styleUrls: ['./conversation-extended-warranty.component.css'],
})
export class ConversationExtendedWarrantyComponent implements OnInit {
  @Input() conversation: Conversation;
  @Output() send: EventEmitter<Event> = new EventEmitter<Event>();

  currentUser: TokenUser;

  constructor(
    private authenticationStateService: AuthenticationStateService,
    private eventsStateService: EventsStateService
  ) {}

  ngOnInit() {
    this.authenticationStateService
      .selectAuthenticatedUser()
      .pipe(
        take(1),
        tap((authenticatedUser: AuthenticatedUser) => {
          this.currentUser = authenticatedUser.user;
        })
      )
      .subscribe();
  }

  gotIt() {
    const event: Event = this.eventsStateService.createEvent(
      `I have this one!`,
      this.conversation.id,
      EventTypes.ExtendedWarrantyGotIt,
      this.currentUser
    );
    this.send.emit(event);
  }
}
